"use client"

import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import type { ViewType } from "@/app/nft/search/result/view/view-selector/types"
import type { ScopeState } from "@/app/nft/search/scope"
import { NftSearchScopeProvider } from "@/app/nft/search/scope-provider"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { ProfileItemsView } from "./view"

interface Props {
  filters: Omit<ScopeState["filters"], "blockchains"> & {
    owner: string
  }
  sort: ScopeState["sort"]
  initialViewType: ViewType
}

export const ProfileItemsReatom = reatomComponent<Props>((props) => {
  const { blockchainsQueryFilter } = useMolecule(
    BlockchainFiltersMoleculeReatom,
  )

  // Call atom directly - requires reatomComponent wrapper
  const blockchains = blockchainsQueryFilter()

  const queryState = {
    filters: {
      ...props.filters,
      blockchains,
    },
    sort: props.sort,
  }

  return (
    <NftSearchScopeProvider state={queryState}>
      <ProfileItemsView initialViewType={props.initialViewType} />
    </NftSearchScopeProvider>
  )
}, "ProfileItemsReatom")
